<template>
  <div>
    <mall-banner></mall-banner>
    <router-view></router-view>
  </div>
</template>

<script>
import MallBanner from './mall/common/banner'
export default {
  components: {
    MallBanner
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/mall.vue